import { useFieldValue, useSetFieldValue } from "formik";
import { AdHocSectionValues } from "../controllers/ad-hoc-section-controller";

interface ISetDiscountRateArgs {
	sectionPath: string;
	fieldPath: string;
	index: number;
	childIndexes: Array<number>;
}

export function useDiscountRate(args: ISetDiscountRateArgs) {
	const { childIndexes, fieldPath, index, sectionPath } = args;
	const [discountRateSectionValue] = useFieldValue<Array<AdHocSectionValues>>(sectionPath);
	const setFieldValue = useSetFieldValue();
	const rateValue = discountRateSectionValue[index][fieldPath];

	const setDiscountRate = () => {
		childIndexes.forEach((childIndex) => {
			const child = discountRateSectionValue[childIndex];
			if (!child[fieldPath]) {
				setFieldValue(`${sectionPath}.${childIndex}.${fieldPath}`, rateValue);
			}
		});
	};

	return setDiscountRate;
}
